module.exports = __webpack_public_path__ + "static/media/podcast-a.e67cfe14.jpg";